import { createContext } from 'react';

type Tcontext = {
    dataForm: Record<string, any>;
    errors: Record<string, string>;
    blur: Record<string, string>;
    isValid: boolean;
    loading: boolean;
    dataFilters: Record<string, any>;
    numberUsers: any;
    selectedUserTypes: string[];
    hasFeatured: boolean;
    showModal: boolean;
    created: boolean;
    customQuery: string;
    customQueryError: string;
    setCustomQuery: (value: string) => void;
    handleSetHasFeatured: (value: boolean) => void;
    handleChange: (name: string, value: any) => void;
    handleSubmit: () => void;
    handleResetForm: () => void;
    handleOpenModal: () => void;
    handleCloseModal: () => void;
    handleSetDataFilters: (name: string, value: any) => void;
    handleGetNumberUsers: () => void;
    handleUserTypeToggle: (typeId: string) => void;
    handleChangeDataFilters: (name: string, value: any) => void;
    handleSetLeadsDate: (name: string, value: any) => void;
};

export const NotificationsContext = createContext<Tcontext>({
    dataForm: {},
    errors: {},
    blur: {},
    isValid: false,
    loading: false,
    dataFilters: {},
    numberUsers: {data: { count_result: 0, count_query: "" }},
    selectedUserTypes: [],
    hasFeatured: false,
    showModal: false,
    created: false,
    customQuery: "",
    customQueryError: "",
    setCustomQuery: () => {},
    handleResetForm: () => {},
    handleSetHasFeatured: () => { },
    handleChange: () => { },
    handleSubmit: () => { },
    handleOpenModal: () => { },
    handleCloseModal: () => { },
    handleSetDataFilters: () => { },
    handleGetNumberUsers: () => { },
    handleUserTypeToggle: () => { },
    handleChangeDataFilters: () => { },
    handleSetLeadsDate: () => { },
});